module.exports = "/call-frontend/img/model_card.c73e783b.png";